import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GameList from "./GameList";
import Game from "./Game";
import {Switch,Route} from 'react-router-dom';
import { ConquestSummary } from './ConquestSummary';
import { TeamDeathMatchSummary } from './TeamDeathMatchSummary';
import { KingoftheHillSummary } from './KingoftheHillSummary';
import { CaptureTheFlagSummary } from './CaptureTheFlagSummary';

const useStyles = makeStyles(theme => ({
    
}));

export default function GameContainer(){

    const classes = useStyles();

    return (
        <Switch>
            <Route exact path={"/game"} component={GameList} />
            <Route path={"/game/tdm/:id"} component={TeamDeathMatchSummary} />
            <Route path={"/game/conquest/:id"} component={ConquestSummary} />
            <Route path={"/game/koh/:id"} component={KingoftheHillSummary} />
            <Route path={"/game/capturetheflag/:id"} component={CaptureTheFlagSummary} />
        </Switch>
    )
}